
const addLangParams = (s_url: string) => {
  const url = new URL(s_url);
  url.searchParams.set('lang', window.VERSION || 'en');
  return url.toString();
};

export const getPortalDocument = (suffix: string) => {
  return `https://${window.AVPORTAL_HOST}/document${suffix}`;
};
export const getPortalLink = (suffix: string) => {
  return `https://${window.AVPORTAL_HOST}${suffix}`;
};

export const getConsoleLink = (suffix: string) => {
  return `https://${window.location.host}${suffix}`;
};


export const getPrimaryConsole = (suffix: string) => {
  const url = `https://${window.QCCONSOLE_HOST}${suffix}`;
  return addLangParams(url);
};

export const getPrimaryLink = (suffix: string) => {
  const url = `https://${window.QCMAIN_HOST}${suffix}`;
  return addLangParams(url);
};

export const getPrimaryBuy = (suffix: string) => {
  const url = `https://${window.QCBUY_HOST}${suffix}`;
  return addLangParams(url);
};


export const getWorkorderPage = (suffix: string = '') => {
  return getPrimaryConsole(`/workorder/category${suffix}`);
};
export const getContactPage = () => {
  return getPortalLink('/contact');
};

export const openPortalPricePage = (suffix = '') => {
  window.open(getPortalLink(`/pricing${suffix}`));
};
export const openRenewalPage = () => {
  window.open(getPrimaryConsole('/expense/renewal'));
};

export const openPortalDocumentPage = (suffix = '') => {
  window.open(getPortalDocument(suffix));
};
export const openContact = () => {
  window.open(getContactPage());
};
